import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex w-5/6" }
const _hoisted_2 = {
  key: 0,
  class: "m-[2%] w-5/6"
}
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = {
  key: 0,
  class: "font-bold light:text-black dark:text-white text-xl"
}
const _hoisted_5 = {
  key: 1,
  class: "font-bold light:text-black dark:text-white text-xl"
}
const _hoisted_6 = {
  key: 0,
  class: "cursor-default"
}
const _hoisted_7 = {
  key: 1,
  class: "cursor-default"
}
const _hoisted_8 = {
  key: 1,
  class: "m-[2%] w-5/6"
}
const _hoisted_9 = { class: "flex justify-between items-center" }
const _hoisted_10 = {
  key: 0,
  class: "font-bold text-black text-xl"
}
const _hoisted_11 = {
  key: 1,
  class: "font-bold text-black text-xl"
}
const _hoisted_12 = { class: "content-center h-full" }
const _hoisted_13 = { class: "text-7xl text-gray-500 font-bold text-center uppercase" }

import {StepBack, Trash2, Download} from "lucide-vue-next";
import {Button} from "@/components/ui/button";
import {onBeforeMount, ref, watch} from "vue";
import TablesService from "@/services/tables/tables.service";
import {useRoute} from "vue-router";
import Spinner from "@/components/ui_custom/spinner/Spinner.vue";
import useEventsBus from "@/utils/eventBus";
import {i18n} from "@/utils/i18n";
import {toast} from "@/utils/utils";
import DeleteDialog from "@/components/tables/DeleteDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentsView',
  setup(__props) {

const items: any = ref([]);
const selected: any = ref([]);
const route = useRoute();
const { bus } = useEventsBus();
let isLoading = ref(false);
const files: any = {
      md: 'mdi-language-markdown',
      pdf: 'mdi-file-pdf-box',
      png: 'mdi-file-image',
      txt: 'mdi-file-document-outline',
      xls: 'mdi-file-excel',
};
const isDeleteDialogOpen = ref(false);

const setIsDeleteDialogOpen = (value: boolean) => {
  isDeleteDialogOpen.value = value;
};

watch(() => bus.value.get('delete_aDocuments'), async () => {
  isLoading.value = true;
  const response = await TablesService.bulkDeleteAttachments(selected.value);
  if (response?.status === 200) {
    const res = await TablesService.getTreeView(route.params.entity as string, route.params.id as string);
    items.value = res?.data
    selected.value = [];
    isLoading.value = false;
    toast.success(i18n.global.t('toast.delete_success'));
  }
})

async function forceFileDownload(item: any) {
  isLoading.value = true;
  const attachment = await TablesService.getAttachmentById(item.id as string, 'documents');
  if (attachment) {
    const link = document.createElement('a')
    link.href = "data:" + item.mimeType + ";base64," + attachment.data
    link.download = item.originalFileName;
    link.click();
  }
  isLoading.value = false;
}

function createSelectedArray(value: any) {
  if (selected.value.includes(value.id)) {
    selected.value = selected.value.filter((selectedId: number) => selectedId !== value.id)
  } else {
    selected.value.push(value.id)
  }
}

onBeforeMount(async () => {
  isLoading.value = true;
  const res = await TablesService.getTreeView(route.params.entity as string, route.params.id as string);
  items.value = res?.data;
  isLoading.value = false;
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_treeview = _resolveComponent("v-treeview")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Spinner, { "is-loading": _unref(isLoading) }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      (items.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Button), {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"])),
                type: "button",
                class: "text-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(StepBack), { class: "mr-2 h-5 w-5" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('building.back')), 1)
                ]),
                _: 1
              }),
              (_unref(route).params.entity === 'buildings')
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('building.documents_list_building')), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('building.documents_list_roof')), 1))
            ]),
            (selected.value.length > 0)
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (setIsDeleteDialogOpen(true)), ["prevent"])),
                  class: "text-center mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Trash2), { class: "mr-2 h-4 w-4" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('table.delete')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_treeview, {
                  items: items.value,
                  activatable: "",
                  selectable: "",
                  "select-strategy": "leaf",
                  "item-value": item => item.id,
                  "onClick:select": _cache[2] || (_cache[2] = value => createSelectedArray(value))
                }, {
                  prepend: _withCtx(({ item }: any) => [
                    (!item.fileName)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                          _createVNode(_component_v_icon, { class: "mr-2" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString('mdi-folder'))
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("label", _hoisted_7, [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(files[item.mimeType.split('/')[1]]), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createTextVNode(" " + _toDisplayString(item.originalFileName), 1)
                        ]))
                  ]),
                  append: _withCtx(({ item }: any) => [
                    (item.fileName)
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 0,
                          onClick: ($event: any) => (forceFileDownload(item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Download))
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["items", "item-value"])
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(Button), {
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"])),
                type: "button",
                class: "text-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(StepBack), { class: "mr-2 h-5 w-5" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('building.back')), 1)
                ]),
                _: 1
              }),
              (_unref(route).params.entity === 'buildings')
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t('building.documents_list_building')), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t('building.documents_list_roof')), 1))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('building.no_documents')), 1)
            ])
          ]))
    ]),
    _createVNode(DeleteDialog, {
      entity: "attachments",
      "a-id": selected.value,
      open: isDeleteDialogOpen.value,
      "set-open": setIsDeleteDialogOpen
    }, null, 8, ["a-id", "open"])
  ], 64))
}
}

})